import { reactive } from 'vue'
import type { RequestScenario } from '@/types/admin'

/** Prototype-only fault injection shared by the request layer and toolbar. */
export const simulatedFault = reactive({
  scenario: 'normal' as RequestScenario,
  latency: 260,
  writeDelay: 480,
  offline: false,
})

export const SCENARIO_LABELS: Record<RequestScenario, string> = {
  normal: '正常',
  timeout: '请求超时',
  cancel: '主动取消',
  '401': '登录过期 401',
  '403': '无权限 403',
  '404': '数据不存在 404',
  '409': '并发冲突 409',
  '422': '校验失败 422',
  '429': '限流 429',
  '500': '服务异常 500',
  offline: '断网',
}

export function resetFaults(): void {
  simulatedFault.scenario = 'normal'
  simulatedFault.latency = 260
  simulatedFault.writeDelay = 480
  simulatedFault.offline = false
}
